<template>
  <roe-error-message :field="design.employer_match_type">
    <v-select
      name="employer_match_type"
      v-model="design.$model.employer_match_type"
      :options="[
        { code: 1, label: 'Fixed Formula' },
        { code: 2, label: 'Can Vary From Year to Year' }
      ]"
      :reduce="label => label.code"
      required
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerMatchTypeSelect",
  components: { RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
